"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = exports.Container = exports.AccordionContent = exports.AccordionHeader = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Accordion'), (0, recompose_1.defaultProps)({
    isOpen: true
}), recompose_1.pure);
var AccordionHeader = function (children) { return (React.createElement("div", { className: classNames('head') }, children)); };
exports.AccordionHeader = AccordionHeader;
var AccordionContent = function (children, isOpen) { return React.createElement("div", { className: classNames('content', { open: isOpen }) }, children); };
exports.AccordionContent = AccordionContent;
var Container = function (className, head, body) { return (React.createElement("div", { className: classNames('sok-accordion', className) },
    head,
    body)); };
exports.Container = Container;
exports.Accordion = enhance(function (_a) {
    var isOpen = _a.isOpen, className = _a.className, _b = _a.children, head = _b[0], body = _b[1];
    return (0, exports.Container)(className, (0, exports.AccordionHeader)(head), (0, exports.AccordionContent)(body, isOpen));
});
//# sourceMappingURL=index.js.map